// extracted by mini-css-extract-plugin
export default {"tabContent":"styles_tab-content__eGRS-","fullScreenTabs":"styles_full-screen-tabs__SK-ID","fullScreenMask":"styles_full-screen-mask__JFhGu"};